/* VAT display switcher — display only, never changes cart/checkout.
   Flips a class on <html> and stores the choice in a 1-year cookie.
   The server-rendered <head> script (vat-init) sets the initial class,
   using the market default; this script handles the dropdown and keeps
   every control in sync. Plain vanilla, no theme module imports. */
(function () {
  var COOKIE = 'vat_mode';

  function write(v) {
    document.cookie = COOKIE + '=' + v + ';path=/;max-age=31536000;samesite=lax';
  }

  function currentMode() {
    return document.documentElement.classList.contains('vat-show-excl') ? 'excl' : 'incl';
  }

  function apply(v) {
    var mode = v === 'excl' ? 'excl' : 'incl';
    var root = document.documentElement;
    root.classList.remove('vat-show-incl', 'vat-show-excl');
    root.classList.add('vat-show-' + mode);
    document.querySelectorAll('[data-vat-select]').forEach(function (sel) {
      if (sel.value !== mode) sel.value = mode;
    });
  }

  // Sync the dropdowns to whatever mode the <head> script already set.
  function init() {
    apply(currentMode());
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('change', function (e) {
    var sel = e.target.closest && e.target.closest('[data-vat-select]');
    if (!sel) return;
    write(sel.value);
    apply(sel.value);
  });

  /* ---- B2B prices (BSS) ----
     For B2B customers the BSS app replaces a price element's content with its
     own markup — a struck retail value plus the discounted value, both incl VAT
     — which wipes the incl/excl spans this theme renders, leaving the toggle
     nothing to switch.

     We do NOT rewrite BSS's markup (that starts a fight: BSS re-renders, we
     re-wrap, forever). Instead each money span BSS rendered is marked as the
     incl view and gets a sibling holding the excl value, so the existing CSS
     toggle handles it. Inert for D2C (no BSS attributes), on the CML checkout
     page, and on tax-excluded / zero-rate markets. */
  var VAT = window.MG_VAT || { rate: 0, inclusive: true };
  var IS_CML = !!document.querySelector('#cml_checkout_start');
  // Scope on the attributes the theme renders, never on BSS's own "processed"
  // markers — BSS does not set those consistently (notably after a variant
  // change), which would leave its prices unwrapped and stuck on incl.
  // Product/variant/line prices only: never the cart "Estimated total", which
  // stays Shopify's own "taxes included" value.
  var BSS_SCOPE = [
    '[bss-b2b-product-price]',
    '[bss-b2b-variant-price]',
    '[bss-b2b-final-line-price]',
    '[bss-b2b-item-final-price]',
    '[bss-b2b-item-original-price]',
  ].join(',');

  function parseMoney(text) {
    var m = (text || '').match(/-?\d[\d\s., ]*/);
    if (!m) return null;
    var s = m[0].replace(/[\s ]/g, '');
    var dec = Math.max(s.lastIndexOf(','), s.lastIndexOf('.'));
    if (dec > -1 && s.length - dec - 1 <= 2) {
      s = s.slice(0, dec).replace(/[.,]/g, '') + '.' + s.slice(dec + 1);
    } else {
      s = s.replace(/[.,]/g, '');
    }
    var n = parseFloat(s);
    return isNaN(n) ? null : n;
  }

  // Format a value using the separators and affixes of a reference money string.
  function formatLike(template, value) {
    var t = (template || '').replace(/ /g, ' ');
    var m = t.match(/-?\d[\d\s.,]*/);
    if (!m) return String(Math.round(value));
    var token = m[0].replace(/\s+$/, '');
    var stripped = token.replace(/\s/g, '');
    var decPos = Math.max(stripped.lastIndexOf(','), stripped.lastIndexOf('.'));
    var decSep = ',';
    if (decPos !== -1 && stripped.length - decPos - 1 >= 1 && stripped.length - decPos - 1 <= 2) {
      decSep = stripped.charAt(decPos);
    }
    var thouSep = /\d\s\d/.test(token) ? ' ' : decSep === ',' ? '.' : ',';
    var parts = value.toFixed(2).split('.');
    var grouped = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thouSep);
    return t.slice(0, m.index) + grouped + decSep + parts[1] + t.slice(m.index + token.length);
  }

  function addExclTwin(sp, factor) {
    var incl = parseMoney(sp.textContent);
    if (incl == null) return;
    var twin = document.createElement('span');
    twin.className = 'vat-amount vat-amount--excl mg-vat-twin';
    var style = sp.getAttribute('style');
    if (style) twin.setAttribute('style', style);
    twin.textContent = formatLike(sp.textContent, incl / factor);
    sp.classList.add('vat-amount', 'vat-amount--incl');
    sp.insertAdjacentElement('afterend', twin);
  }

  function syncBssPrices() {
    if (IS_CML || !VAT.rate || !VAT.inclusive) return;
    var factor = 1 + VAT.rate / 100;
    document.querySelectorAll(BSS_SCOPE).forEach(function (scope) {
      scope.querySelectorAll('span').forEach(function (sp) {
        if (sp.children.length) return; // leaf spans only
        if (sp.classList.contains('vat-amount')) return; // ours already, or theme-rendered
        addExclTwin(sp, factor);
      });
    });
  }

  // BSS renders and re-renders asynchronously (load, scroll, cart update,
  // variant change), so re-check whenever the DOM settles.
  if (!IS_CML && VAT.rate && VAT.inclusive) {
    /* Wrap as soon as BSS renders, not on a debounce: until the excl twin
       exists, BSS's unclassed spans show the incl value in both modes, so any
       delay is a visible wrong price. Leading-edge throttle keeps it immediate
       for the first mutation of a burst while bounding the cost during scroll. */
    var lastRun = 0;
    var pending = false;
    var THROTTLE_MS = 50;
    var scheduleSync = function () {
      var since = Date.now() - lastRun;
      if (since >= THROTTLE_MS) {
        lastRun = Date.now();
        syncBssPrices();
        return;
      }
      // Never reset an already queued run: this page mutates constantly (chat
      // widget, lazy images) and resetting would starve it for a second.
      if (pending) return;
      pending = true;
      setTimeout(function () {
        pending = false;
        lastRun = Date.now();
        syncBssPrices();
      }, THROTTLE_MS - since);
    };

    // A variant change or cart update makes BSS re-render its price roughly half
    // a second later; until we have wrapped it, BSS's unclassed spans show the
    // incl value in both modes. Retry across that window so the excl twin is in
    // place as soon as BSS is done.
    var retryTimers = [];
    var scheduleRetries = function () {
      retryTimers.forEach(clearTimeout);
      retryTimers = [100, 350, 700, 1200, 2000].map(function (delay) {
        return setTimeout(syncBssPrices, delay);
      });
    };

    scheduleSync();
    document.addEventListener('cart:update', scheduleRetries);
    document.addEventListener('variant:update', scheduleRetries);
    new MutationObserver(scheduleSync).observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true,
    });
  }
})();
